export const SERVER = "https://api.bellywelly.kro.kr";
export const SERVER_AI = "https://model.bellywelly.kro.kr";
